import { registerCapability } from '../../platform/capability-registry';
import { BaseInfoBlock } from './BaseInfoBlock';
import { BASE_INFO_FIELD_KEY_LIST } from './fieldKeys';
import { resolveBaseInfoPaths } from './resolvePaths';
import type { BaseInfoBlockOptions } from './types';

registerCapability<BaseInfoBlockOptions>({
  key: 'base-info',
  fields: [...BASE_INFO_FIELD_KEY_LIST],
  component: BaseInfoBlock,
  defaultPaths: (prefix) => resolveBaseInfoPaths(prefix),
  resolvePaths: (prefix, options) => resolveBaseInfoPaths(prefix, options),
});
